// Omnix/common/schemas/collections/telephonyAudioFiles.js
import { z } from "zod";

const TelephonyAudioFileSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this audio file belongs to."),
    
    name: z.string().min(1, "A friendly name for the audio file is required."),
    group: z.string().min(1, "A group name is required for organization."),
    description: z.string().optional().nullable(),
    
    sourceType: z.enum(['upload', 'recording', 'tts']).describe("The origin of the audio file."),
    
    // Object Store Details
    storageProvider: z.string().describe("The name of the configured object store provider (e.g., 'seaweedfs')."),
    bucketName: z.string().describe("The name of the bucket where the file is stored."),
    objectName: z.string().describe("The full path/key of the file within the bucket."),
    // File Metadata
    mimeType: z.string(),
    size: z.number().int().positive().describe("Size of the file in bytes."),
    duration: z.number().optional().nullable().describe("Duration of the audio in seconds."),
    
    // For TTS source
    ttsSourceText: z.string().optional().nullable(),
    ttsModel: z.string().optional().nullable(),
    ttsVoice: z.string().optional().nullable(),
    
    createdBy: z.string().describe("The userId of the user who created this file."),
    createdAt: z.coerce.date().optional(),
});

export default TelephonyAudioFileSchema;
